import axios from 'axios';
import { InstancePlatform } from 'types/cluster';
import {
  PlatFormActionsResponse,
  PlatformsListResponse,
  PlatformActionsResponse,
  RoleCapabilities,
} from 'types/platformAction';
import { API_URL } from 'utils/http';

// ── Legacy endpoints (kept for backward compatibility) ──────────────────

export function fetchPlatformActions() {
  return axios.get<PlatFormActionsResponse>(`${API_URL}/platform`);
}

export function updatePlatformAction(payload: {
  action: string;
  platform: InstancePlatform;
  status: boolean;
}) {
  return axios.post(`${API_URL}/platform`, payload);
}

// ── New platform-centric endpoints ──────────────────────────────────────

export function fetchPlatforms() {
  return axios.get<PlatformsListResponse>(`${API_URL}/platforms`);
}

export function fetchPlatformActionsByCode(
  code: string,
  roleID?: number,
) {
  return axios.get<PlatformActionsResponse>(`${API_URL}/platforms/${code}/actions`, {
    params: roleID ? { roleID } : undefined,
  });
}

export function fetchRoleCapabilities(roleID: number) {
  return axios.get<RoleCapabilities>(
    `${API_URL}/platforms/roles/${roleID}`,
  );
}

export function updatePlatformActionMapping(
  code: string,
  actionName: string,
  enabled: boolean,
) {
  return axios.put(`${API_URL}/platforms/${code}/actions/${actionName}`, {
    enabled,
  });
}

export function updateRolePlatform(
  roleID: number,
  code: string,
  enabled: boolean,
) {
  return axios.put(
    `${API_URL}/platforms/roles/${roleID}/platforms/${code}`,
    { enabled },
  );
}

export function updateRoleAction(
  roleID: number,
  actionName: string,
  enabled: boolean,
) {
  return axios.put(
    `${API_URL}/platforms/roles/${roleID}/actions/${actionName}`,
    { enabled },
  );
}
